import { useState, useCallback } from 'react'
import { HelpOther } from '@/common/helper'
import { ACCEPT_IMG_TYPE } from '@/components/input-file/shared'

const MAX_IMG_SIZE = 200
const MAX_FILE_COUNT = 100
const useFilePaste = () => { 
  const [pasteFiles, setPasteFiles] = useState([])
 
  const handlePasteChange = useCallback((event, len = null) => {
    const items = event?.clipboardData?.items || []
    let files = []

    for (let i=0; i<items.length; i++) {
      if (items[i]?.type?.indexOf('image') > -1) {
        files.push(items[i]?.getAsFile())
      }
    }

    const limit = len || MAX_FILE_COUNT
    if (files.length > limit) {
      HelpOther.toast(`最多只能上传${limit}张图片`, 'info')
      // 如果限制，取前面limit个
      files = files.slice(0, limit)
    }

    console.info('>>> 正在粘贴数据', files)

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileType = file.name.slice(file.name.lastIndexOf('.'))
      if (file.size > 1024 * 1024 * MAX_IMG_SIZE) {
        HelpOther.toast(`图片大小不能超过 ${MAX_IMG_SIZE}MB`, 'info')
        return
      }
      if (!ACCEPT_IMG_TYPE.includes(fileType.toLocaleLowerCase())) {
        HelpOther.toast(`不支持的图片类型`, 'info')
        return
      }
    }

    if(files?.length) {
      event.preventDefault()
      setPasteFiles(files)
    }
  }, [])
 
  return { pasteFiles, setPasteFiles, handlePasteChange }
}
 
export default useFilePaste
